import { Fragment, useImperativeHandle, useState } from 'react';
import { Button, DialogProps } from 'tdesign-react';

import NovaDialog from '../dialog';

export interface ITipDialogRef {
  close: () => void;
  open: () => void;
}

/**
 * 表单错误提示信息组件
 */
function TipDialog(props: {
  tipRef?: React.ForwardedRef<ITipDialogRef>;
  notTip?: boolean;
  message?: string | React.ReactElement;
  dialogConfig?: DialogProps;
  confirmCallback?: () => void;
  closeCallback?: () => void;
}) {
  const { message, tipRef, closeCallback, notTip, dialogConfig } = props;

  useImperativeHandle(tipRef, () => ({
    close,
    open,
  }));

  const [visible, setVisible] = useState(false);

  const close = () => {
    closeCallback?.();
    setVisible(false);
  };

  const open = () => {
    if (notTip) {
      return;
    }
    setVisible(true);
  };

  return (
    <Fragment>
      <NovaDialog
        dialogConfig={{
          visible,
          onClose: close,
          confirmBtn: (
            <Button theme='primary' onClick={close}>
              确定
            </Button>
          ),
          cancelBtn: null,
          theme: 'warning',
          header: '提示',
          placement: 'center',
          ...dialogConfig,
        }}
      >
        <div className={'nova-save-tips'}>
          {message ? message : '信息未填写或信息不完整，请完善信息。'}
        </div>
      </NovaDialog>
    </Fragment>
  );
}

export default TipDialog;
